import { HttpClient, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataPoint } from 'src/app/models/datapoint.model';
import { Unit } from 'src/app/models/unit.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataPointService {

  baseUrl: string = environment.apiUrl
  constructor(private http : HttpClient) { }

  retrieveDataPoint() : Observable<DataPoint[]> {
    return this.http.get<DataPoint[]>(this.baseUrl + '/datapoint')
  }

  retrieveDataPointById(id: string) : Observable<DataPoint> {
    return this.http.get<DataPoint>(this.baseUrl + '/dataPoint/' + id)
  }

  retrieveUnitByPlantId(id: string) : Observable<Unit[]> {
    return this.http.get<Unit[]>(this.baseUrl + '/unit/plant/' + id)
  }

  retrieveDataPointByUnitId(id: string, showDeleted: string = "false") : Observable<DataPoint[]> {
    return this.http.get<DataPoint[]>(this.baseUrl + '/datapoint/unit/' + id + `?showDeleted=${showDeleted}`)
  }

  retrieveDataPointByPlantId(id: string, showDeleted: string = "false") : Observable<DataPoint[]> {
    return this.http.get<DataPoint[]>(this.baseUrl + '/datapoint/plant/' + id + `?showDeleted=${showDeleted}`)
  }

  retrieveDataPointByUnitIdPaginated(id: string, pageNumber:number, pageSize:number, showDeleted: string = "false") : Observable<DataPoint[]> {
    return this.http.get<DataPoint[]>(`${this.baseUrl}/datapoint/unit/${id}/${pageNumber}/${pageSize}?showDeleted=${showDeleted}`)
  }

  retrieveActiveDataPoints() : Observable<DataPoint[]> {
    return this.http.get<DataPoint[]>(this.baseUrl + '/datapoint/active')
  }

  // Uploads a file for a "File Upload" data point, reporting progress events so the
  // form can animate the upload. The final Response body carries the stored file's id.
  uploadDataPointFile(file: File): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(this.baseUrl + '/datapoint/file', formData, {
      reportProgress: true,
      observe: 'events',
    });
  }

  // Downloads a previously uploaded data point file through HttpClient so the
  // auth interceptor attaches the JWT (a plain <a href> navigation would not,
  // and the endpoint requires authentication).
  downloadDataPointFile(id: string | number): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.baseUrl}/datapoint/file/${id}`, {
      responseType: 'blob',
      observe: 'response',
    });
  }

  addDataPoint(addDataPointRequest : DataPoint) : Observable<DataPoint> {
    // const formData = new FormData();

    // Object.keys(addDataPointRequest).forEach((key,value)=>{
    //   formData.append(key, value.toString());
    // })
    // formData.append("file", selectedFile);
    return this.http.post<DataPoint>(this.baseUrl + '/datapoint', addDataPointRequest)
  }

  editDataPoint(id: number, editDataPointRequest : DataPoint) : Observable<DataPoint> {
    return this.http.patch<DataPoint>(this.baseUrl + '/datapoint/' + id, editDataPointRequest)
  }

  deactivateDataPoint(id: any) : Observable<DataPoint> {
    return this.http.patch<DataPoint>(this.baseUrl + '/datapoint/deactivate/' + id, {})
  }
}
